'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CHART_TYPE_GAUGE = exports.CHART_TYPE_PIE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
    var store = _ref.store,
        layout = _ref.layout,
        el = _ref.el,
        extraConfig = _ref.extraConfig,
        extraOptions = _ref.extraOptions;

    var series = store.generateData({
        seriesId: layout.columns[0].dimension,
        categoryId: layout.rows[0].dimension
    });

    var isStacked = (0, _type.getIsStacked)(layout.type);

    var config = {

        // type etc
        chart: (0, _chart2.default)(layout, el, extraOptions.dashboard),

        // title
        title: (0, _title2.default)(layout, store.data.metaData, extraOptions.dashboard),

        // subtitle
        subtitle: (0, _subtitle2.default)(series, layout, store.data.metaData, extraOptions.dashboard),

        // x-axis
        xAxis: (0, _xAxis2.default)(store, layout),

        // y-axis
        yAxis: (0, _yAxis2.default)(layout, extraOptions),

        // series
        series: (0, _series2.default)(series.slice(), store, layout, isStacked, extraOptions),

        // legend
        legend: (0, _legend2.default)(layout, extraOptions.dashboard),

        // pane
        pane: (0, _pane2.default)(layout.type),

        // no data
        noData: (0, _noData2.default)(),

        // credits
        credits: {
            enabled: false
        },

        // exporting
        exporting: {
            // disable exporting context menu
            enabled: false
        }
    };

    // hide empty categories
    if (layout.hideEmptyRowItems !== 'NONE') {
        config = (0, _getTrimmedConfig2.default)(config, layout.hideEmptyRowItems);
    }

    // sorting
    if (layout.sortOrder) {
        config = (0, _getSortedConfig2.default)(config, layout, isStacked);
    }

    // DHIS2-1243 add trend lines after sorting
    // trend line on pie and gauge does not make sense
    if (layout.type !== CHART_TYPE_GAUGE && layout.type !== CHART_TYPE_PIE && layout.regressionType !== 'NONE') {
        config.series = (0, _addTrendLines2.default)(layout.regressionType, config.series, isStacked);
    }

    // force apply extra config
    _extends(config, extraConfig);

    return (0, _objectClean2.default)(config);
};

var _objectClean = require('d2-utilizr/lib/objectClean');

var _objectClean2 = _interopRequireDefault(_objectClean);

var _chart = require('./chart');

var _chart2 = _interopRequireDefault(_chart);

var _xAxis = require('./xAxis');

var _xAxis2 = _interopRequireDefault(_xAxis);

var _yAxis = require('./yAxis');

var _yAxis2 = _interopRequireDefault(_yAxis);

var _series = require('./series');

var _series2 = _interopRequireDefault(_series);

var _title = require('./title');

var _title2 = _interopRequireDefault(_title);

var _subtitle = require('./subtitle');

var _subtitle2 = _interopRequireDefault(_subtitle);

var _legend = require('./legend');

var _legend2 = _interopRequireDefault(_legend);

var _pane = require('./pane');

var _pane2 = _interopRequireDefault(_pane);

var _noData = require('./noData');

var _noData2 = _interopRequireDefault(_noData);

var _type = require('./type');

var _getSortedConfig = require('./getSortedConfig');

var _getSortedConfig2 = _interopRequireDefault(_getSortedConfig);

var _getTrimmedConfig = require('./getTrimmedConfig');

var _getTrimmedConfig2 = _interopRequireDefault(_getTrimmedConfig);

var _addTrendLines = require('./addTrendLines');

var _addTrendLines2 = _interopRequireDefault(_addTrendLines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHART_TYPE_PIE = exports.CHART_TYPE_PIE = 'pie';
var CHART_TYPE_GAUGE = exports.CHART_TYPE_GAUGE = 'gauge';
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/index.js
 ** module id = 17
 ** module chunks = 0 1
 **/